const { CycleResolutionPopup } = require("@bryntum/gantt");

export class CustomCycleResolutionPopup extends CycleResolutionPopup {
    getResolutions() {
        let res = this.schedulingIssue?.getResolutions(); // this will return the resolutions
        if (res !== undefined && res.length > 0) {
            // codition
            res = res.filter(x => !x.isDeactivateDependencyCycleEffectResolution)
        }
        // according to this, it will show the radio buttons
        return res;
    }
}